import access from './pcmodules/access';
import accessDucks from './pcmodules/access/ducks';
import account from './pcmodules/account';
import accountDucks from './pcmodules/account/ducks';
import activity from './pcmodules/activity';
import activityDucks from './pcmodules/activity/ducks';
import dingboss from './pcmodules/dingboss';
import dingbossDucks from './pcmodules/dingboss/ducks';
import divide from './pcmodules/divide';
import divideDucks from './pcmodules/divide/ducks';
import example from './pcmodules/example';
import exampleDucks from './pcmodules/example/ducks';
import guard from './pcmodules/guard';
import guardDucks from './pcmodules/guard/ducks';
import home from './pcmodules/home';
import homeDucks from './pcmodules/home/ducks';
import homeunbundl from './pcmodules/homeunbundl';
import homeunbundlDucks from './pcmodules/homeunbundl/ducks';
import kele from './pcmodules/kele';
import keleDucks from './pcmodules/kele/ducks';
import property from './pcmodules/property';
import propertyDucks from './pcmodules/property/ducks';
import tcommunity from './pcmodules/tcommunity';
import tcommunityDucks from './pcmodules/tcommunity/ducks';
import thome from './pcmodules/thome';
import thomeDucks from './pcmodules/thome/ducks';
import thousehold from './pcmodules/thousehold';
import thouseholdDucks from './pcmodules/thousehold/ducks';
import tmarketing from './pcmodules/tmarketing';
import tmarketingDucks from './pcmodules/tmarketing/ducks';
import wx from './pcmodules/wx';
import wxDucks from './pcmodules/wx/ducks';
import wxdata from './pcmodules/wxdata';
import wxdataDucks from './pcmodules/wxdata/ducks';
import wxfans from './pcmodules/wxfans';
import wxfansDucks from './pcmodules/wxfans/ducks';
import wxmenu from './pcmodules/wxmenu';
import wxmenuDucks from './pcmodules/wxmenu/ducks';
import wxminiapp from './pcmodules/wxminiapp';
import wxminiappDucks from './pcmodules/wxminiapp/ducks';
import wxnews from './pcmodules/wxnews';
import wxnewsDucks from './pcmodules/wxnews/ducks';

const routes = [...access, ...account, ...activity, ...dingboss, ...divide, ...example, ...guard, ...home, ...homeunbundl, ...kele, ...property, ...tcommunity, ...thome, ...thousehold, ...tmarketing, ...wx, ...wxdata, ...wxfans, ...wxmenu, ...wxminiapp, ...wxnews];

const modules = { access: accessDucks, account: accountDucks, activity: activityDucks, dingboss: dingbossDucks, divide: divideDucks, example: exampleDucks, guard: guardDucks, home: homeDucks, homeunbundl: homeunbundlDucks, kele: keleDucks, property: propertyDucks, tcommunity: tcommunityDucks, thome: thomeDucks, thousehold: thouseholdDucks, tmarketing: tmarketingDucks, wx: wxDucks, wxdata: wxdataDucks, wxfans: wxfansDucks, wxmenu: wxmenuDucks, wxminiapp: wxminiappDucks, wxnews: wxnewsDucks };

export { routes, modules };
